/* eslint-disable import/prefer-default-export */

/**
 *
 * Expects: cmMin, cmMax, cmInterval,
 *          kgMin, kgMax, kgInterval,
 *          shoeMin, shoeMax, shoeInterval,
 *          clothGroup (optional: adult, child_youth)
 * $t - translation function
 *
 * Returns: { lengthOptions, weightOptions, shoeSizeOptions, clothSizeOptions }
 */
export const createValidMeasurements = (config, $t) => {
  const lengthOptions = [];
  const weightOptions = [];
  const shoeSizeOptions = [];
  let clothSizeOptions = [];
  const clothOptionGroups = {};

  let i = config.cmMin;
  let max = config.cmMax;
  let interval = config.cmInterval || 5;
  const cmlang = $t('skirental.measurements.centimeter-short');
  while (i <= max) {
    const title = `${i} ${cmlang}`;
    let subtitle = '';
    if (i === config.cmMin) {
      subtitle = $t('skirental.rules.or-shorter', { measurement: '' });
    } else if (i === config.cmMax) {
      subtitle = $t('skirental.rules.or-longer', { measurement: '' });
    }
    lengthOptions.push({
      title,
      subtitle,
      value: i,
    });
    i += interval;
  }

  i = config.kgMin;
  max = config.kgMax;
  interval = config.kgInterval || 5;
  const kg = $t('skirental.measurements.kilogram-short');
  while (i <= max) {
    const title = `${i} ${kg}`;
    let subtitle = '';
    if (i === config.kgMin) {
      subtitle = $t('skirental.rules.or-less', { measurement: '' });
    } else if (i === config.kgMax) {
      subtitle = $t('skirental.rules.or-more', { measurement: '' });
    }
    weightOptions.push({
      title,
      subtitle,
      value: i,
    });
    i += interval;
  }

  i = Math.max(24, config.shoeMin);
  max = Math.min(52, config.shoeMax);
  interval = config.shoeInterval || 1;

  const table = {
    24: ['24', '15.0'],
    25: ['25', '15.5'],
    26: ['26', '16.5'],
    27: ['27', '17.0'],
    28: ['28', '17.5'],
    29: ['29', '18.5'],
    30: ['30', '19.5'],
    31: ['31', '20.5'],
    32: ['32', '21.5'],
    33: ['33', '22.0'],
    34: ['34', '22.5'],
    35: ['35', '23.0'],
    36: ['36', '23.5'],
    37: ['37', '24.0'],
    38: ['38', '24.5'],
    39: ['39', '25.0'],
    40: ['40', '26.0'],
    41: ['41', '26.5'],
    42: ['42', '27.5'],
    43: ['43', '28.0'],
    44: ['44', '28.5'],
    45: ['45', '29.5'],
    46: ['46', '30.5'],
    47: ['47', '31.0'],
    48: ['48', '32.0'],
    49: ['49', '33.0'],
  };

  while (i <= max) {
    const size = table[i];
    const subtitle = size[1].toLocaleString('arab', {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    });
    const cm = $t('skirental.measurements.centimeter-short');
    shoeSizeOptions.push({
      title: size[0],
      subtitle: `${subtitle} ${cm}`,
      value: i,
    });
    i += interval;
  }

  clothOptionGroups.adult = [
    { title: 'XS', value: 'XS', subtitle: '' },
    { title: 'S', value: 'S', subtitle: '' },
    { title: 'M', value: 'M', subtitle: '' },
    { title: 'L', value: 'L', subtitle: '' },
    { title: 'XL', value: 'XL', subtitle: '' },
    { title: 'XXL', value: 'XXL', subtitle: '' },
    { title: 'XXXL', value: 'XXXL', subtitle: '' },
    { title: 'XXXXL', value: 'XXXXL', subtitle: '' },
    { title: 'XXXXXL', value: 'XXXXXL', subtitle: '' },
  ];

  clothOptionGroups.child_youth = [
    // { title: "110-116", value: "110-116", subtitle: "" },
    { title: '122-128', value: '122-128', subtitle: '' },
    { title: '134-140', value: '134-140', subtitle: '' },
    { title: '146-152', value: '146-152', subtitle: '' },
    { title: '158-164', value: '158-164', subtitle: '' },
  ];

  if (config.clothGroup && clothOptionGroups[config.clothGroup]) {
    clothSizeOptions = clothOptionGroups[config.clothGroup];
  } else {
    // Merge all options
    clothSizeOptions = [
      ...clothOptionGroups.adult,
      ...clothOptionGroups.child_youth,
    ];
  }

  return {
    lengthOptions,
    weightOptions,
    shoeSizeOptions,
    clothSizeOptions,
  };
};



// WEBPACK FOOTER //
// ./src/lib/measurements.js